module.exports = __webpack_public_path__ + "img/QC.78fcd70f.png";